import { render, staticRenderFns } from "./goods3dh5setting.vue?vue&type=template&id=6bdf5b28&scoped=true"
import script from "./goods3dh5setting.vue?vue&type=script&lang=js"
export * from "./goods3dh5setting.vue?vue&type=script&lang=js"
import style0 from "./goods3dh5setting.vue?vue&type=style&index=0&id=6bdf5b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___f047bfa682af2a89903e2d84cf35ffa3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf5b28",
  null
  
)

export default component.exports